import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import NotificationMetrics from '../components/notifications/NotificationMetrics';
import NotificationLogTable from '../components/notifications/NotificationLogTable';
import ScheduleManager from '../components/notifications/ScheduleManager';
import TemplateEditor from '../components/notifications/TemplateEditor';
import SendReminderPanel from '../components/notifications/SendReminderPanel';
import NotificationTrendChart from '../components/notifications/NotificationTrendChart';
import TriggerBreakdownChart from '../components/notifications/TriggerBreakdownChart';
import PageHeader from '../components/ui/PageHeader';

const { FiBarChart2, FiList, FiClock, FiFileText } = FiIcons;

const TABS = [
  { id: 'overview',   label: 'Overview',          icon: FiBarChart2 },
  { id: 'log',        label: 'Notification Log',  icon: FiList      },
  { id: 'schedules',  label: 'Schedules',          icon: FiClock     },
  { id: 'templates',  label: 'Templates',          icon: FiFileText  },
];

const Notifications = () => {
  const [tab, setTab] = useState('overview');
  const [logRefreshKey, setLogRefreshKey] = useState(0);
  const refreshNotificationLog = () => setLogRefreshKey(value => value + 1);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6 max-w-[1400px] mx-auto">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <PageHeader eyebrow="Automation" title="Notifications" description="Automate training reminders, compliance alerts, and phishing follow-ups." />
        <div className="flex gap-1 bg-white border border-slate-200 rounded-lg p-1 shadow-sm flex-shrink-0">
          {TABS.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)}
              className={`flex items-center gap-2 px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${tab === t.id ? 'bg-[#0f172a] text-white' : 'text-slate-600 hover:bg-slate-100'}`}>
              <SafeIcon icon={t.icon} className="text-sm" />{t.label}
            </button>
          ))}
        </div>
      </div>

      <NotificationMetrics />

      <AnimatePresence mode="wait">
        {tab === 'overview' && (
          <motion.div key="overview" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} className="space-y-6">
            <NotificationTrendChart />
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2"><NotificationLogTable refreshKey={logRefreshKey} /></div>
              <div className="space-y-6"><TriggerBreakdownChart /><SendReminderPanel onLogRefresh={refreshNotificationLog} /></div>
            </div>
          </motion.div>
        )}
        {tab === 'log' && (
          <motion.div key="log" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
            <NotificationLogTable refreshKey={logRefreshKey} />
          </motion.div>
        )}
        {tab === 'schedules' && (
          <motion.div key="schedules" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} className="grid grid-cols-1 xl:grid-cols-3 gap-6">
            <div className="xl:col-span-2"><ScheduleManager /></div>
            <SendReminderPanel onLogRefresh={refreshNotificationLog} />
          </motion.div>
        )}
        {tab === 'templates' && (
          <motion.div key="templates" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
            <TemplateEditor />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default Notifications;